import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Container, Label } from "reactstrap";
import "./index.css";
import Loading from "../../components/Loading";
import { HomeProps } from "./type";
import { createLoadingSelector } from "reducers/selectors";
import ActionTypes from "actions/ActionTypes";
import { bindActionCreators, Dispatch } from "redux";
import actions from "actions";
import { connect } from "react-redux";
import t from "utils/Lang";
import { useHistory } from "react-router-dom";

const loadingSelector = createLoadingSelector([ActionTypes.USER_PREFIX]);

// The Roster component matches one of two different routes
// depending on the full pathname

declare var window: any;

const Home = ({ user, loading }: HomeProps) => {
  const history = useHistory();
  const search = window.location.search;
  const searchParams = new URLSearchParams(search);
  const redirectTo = searchParams.get('redirect_to');

  const [subscriptionState, setSubscriptionState] = useState<any>({
    isPushEnabled: false,
    isOptedOut: false,
  });

  const getSubscriptionState = () => {
    const OneSignal = window.OneSignal || [];
    if (OneSignal?.isPushNotificationsEnabled && OneSignal?.isOptedOut) {
      return Promise.all([
        OneSignal?.isPushNotificationsEnabled(),
        OneSignal?.isOptedOut(),
      ]).then(function (result) {
        var isPushEnabled = result[0];
        var isOptedOut = result[1];
        const newSubscriptionState = {
          isPushEnabled: isPushEnabled,
          isOptedOut: isOptedOut,
        };
        setSubscriptionState(newSubscriptionState);
      });
    }
  };

  useEffect(() => {
    getSubscriptionState();
  }, []);

  useEffect(() => {
    if (redirectTo) {
      history.push(redirectTo);
    }
  }, [redirectTo]);

  if (loading) return <Loading />;

  const conditionalActive = () => {
    return (
      user?.roles?.find((role: any) => role.name == "TCH Store Manager") == null
    );
  };

  const homePage = [
    {
      id: 0,
      title: t().home__site_listing,
      icon: "pin_drop",
      path: "/sitev2",
      active: conditionalActive(),
    },
    {
      id: 1,
      title: t().home__my_site,
      icon: "person",
      path: `/sitev2?assignee_user_id=${user?.id}`,
      active: user?.id && conditionalActive(),
    },
    {
      id: 2,
      title: t().home__store_listing,
      icon: "store",
      path: "/store",
      active: conditionalActive(),
    },
    {
      id: 3,
      title: t().home__market_info,
      icon: "location_city",
      path: "/market_information",
      active: true,
    },
    {
      id: 4,
      title: t().home__site_planning_zone,
      icon: "map",
      path: "/planning/map",
      active: conditionalActive(),
    },
    {
      id: 4.5,
      title: t().home__old_map,
      icon: "map",
      path: "/planning/mapbox",
      active: conditionalActive(),
    },
    {
      id: 5,
      title: t().home__change_password,
      icon: "lock",
      path: "/reset_password",
      active: true,
    },
    {
      id: 6,
      title: t().home__settings,
      icon: "settings",
      path: "/settings",
      active: user?.user_brand?.is_brand_admin_user && conditionalActive(),
    },
    {
      id: 7,
      title: "IFRS COMPLIANCE",
      icon: "account_balance",
      path: "/finance/ifrs",
      active: true,
    },
  ];

  return (
    <Container>
      <Row>
        <Col className="home-current-user-brand" xs={12}>
          <img
            className="home-current-user-brand-img"
            src={user?.user_brand?.brand_logo_image}
            alt={user?.user_brand?.brand_name}
          />
          <span className="home-current-user-brand-name">
            {user?.user_brand?.brand_name}
          </span>
        </Col>
      </Row>
      <Row>
        {homePage
          .filter((page) => page.active)
          .map((page) => (
            <Col
              xs={12}
              md={4}
              tag={Link}
              to={page.path}
              style={styles.block}
              key={page.id}
            >
              <div style={styles.item}>
                <i className="material-icons" style={styles.icon}>
                  {page.icon}
                </i>
                <Label style={styles.title}>{page.title}</Label>
              </div>
            </Col>
          ))}
      </Row>
    </Container>
  );
};

const styles: { [name: string]: React.CSSProperties } = {
  block: {
    marginTop: 20,
  },
  item: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#263F76",
    borderRadius: 5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 25,
    paddingBottom: 25,
  },
  title: {
    marginTop: 15,
    fontWeight: 1000,
    fontSize: 20,
    color: "#263F76",
  },
  icon: {
    fontSize: 36,
    color: "#263F76",
  },
  notificationButton: {
    marginTop: 24,
  },
};

const mapStateToProps = (state: any) => {
  return {
    loading: loadingSelector(state),
    user: state.user.data,
    homePages: state.configs.homePages,
  };
};

const mapActionsToProps = (dispatch: Dispatch) =>
  bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapActionsToProps)(Home);
